import { Controller } from "@hotwired/stimulus"

// The rooms list: keeps the "who is inside" blocks fresh by polling, and
// filters the cards by name and by tab (all / private / online).
export default class extends Controller {
  static targets = ["search", "tab", "empty"]
  static values = { url: String, interval: { type: Number, default: 10000 } }

  connect() {
    this.filter = "all"
    this.timer = setInterval(() => this.refresh(), this.intervalValue)
    this.onVisible = () => { if (document.visibilityState === "visible") this.refresh() }
    document.addEventListener("visibilitychange", this.onVisible)
  }

  disconnect() {
    clearInterval(this.timer)
    document.removeEventListener("visibilitychange", this.onVisible)
  }

  async refresh() {
    if (document.visibilityState !== "visible") return
    let rooms
    try {
      const response = await fetch(this.urlValue, { headers: { Accept: "application/json" }, credentials: "same-origin" })
      if (!response.ok) return
      rooms = await response.json()
    } catch (_) { return }

    this.cards.forEach((card) => {
      const data = rooms[card.dataset.roomId]
      if (!data) return
      card.dataset.online = String(data.count > 0)
      const block = card.querySelector("[data-room-presence]")
      if (block && block.innerHTML !== data.html) block.innerHTML = data.html
    })
    this.apply()
  }

  tab(event) {
    this.filter = event.currentTarget.dataset.filter
    this.tabTargets.forEach((t) => t.classList.toggle("tab-active", t === event.currentTarget))
    this.apply()
  }

  apply() {
    const query = this.hasSearchTarget ? this.searchTarget.value.trim().toLowerCase() : ""
    let shown = 0
    this.cards.forEach((card) => {
      const byName = !query || card.dataset.name.includes(query)
      const byTab = this.filter === "all"
        || (this.filter === "private" && card.dataset.private === "true")
        || (this.filter === "online" && card.dataset.online === "true")
      const visible = byName && byTab
      card.hidden = !visible
      if (visible) shown += 1
    })
    // A section with nothing left to show takes its heading with it.
    this.element.querySelectorAll("[data-room-section]").forEach((section) => {
      section.hidden = !section.querySelector("[data-room-card]:not([hidden])")
    })
    if (this.hasEmptyTarget) this.emptyTarget.hidden = shown > 0
  }

  get cards() {
    return this.element.querySelectorAll("[data-room-card]")
  }
}
